<div class="fpx-form-control">
  <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
  <div class="fpx-field-content">
    <mat-select (infiniteScroll)="this.enableInfiniteScroll && onScroll()" msInfiniteScroll #select [formControl]="formControl" [class]="ngTemplateName" panelClass="fpx-select-panel {{ngTemplateName}}" 
      [ngClass]="{'input-available': formControl.value, 'ng-template-select': ngTemplateName}"
      [disableOptionCentering]="disableOptionCentering">
      <mat-select-trigger>
        <ng-container [ngTemplateOutlet]="ngTemplateName && selectedData ? getTemplate(ngTemplateName) : defaultTemplate" [ngTemplateOutletContext]="{ $implicit: selectedData }"></ng-container>
      </mat-select-trigger>

      <ng-container *ngIf="selectableList$ | async as selectableDataList">
        <ng-container>{{setInitialSelectedData(selectableDataList)}}</ng-container>
        <mat-option *ngFor="let selectableData of selectableDataList" [value]="selectableData.id" 
          (onSelectionChange)="onSelectionChange($event, selectableData)">
          <ng-container [ngTemplateOutlet]="ngTemplateName ? getTemplate(ngTemplateName) : defaultTemplate" [ngTemplateOutletContext]="{ $implicit: selectableData, index: i }" >
          </ng-container>
          
        </mat-option>
      </ng-container>
    </mat-select>
    
    <mat-placeholder *ngIf="placeholder" class="placeholder">
      {{ placeholder }}
    </mat-placeholder>
    
  </div>
  <mat-hint class="hint" *ngIf="hint" [innerHtml]="hint"></mat-hint>
  <mat-error *ngIf="formControl && formControl.invalid &&  formControl.touched">
    {{errorCode}}
 </mat-error>
</div>

<ng-template #defaultTemplate let-selectableData>{{ selectableData?.text }}</ng-template>